module.exports = __webpack_public_path__ + "static/media/horoscope-icon-white-10.392d5f36.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/horoscopes/horoscope-icon-white-10.png
// module id = 190
// module chunks = 0